import { RoutedAppErrorPage } from "@/components/common/pages/error-screen";
import { appErrorSearchSchema } from "@/lib/app-error-routes";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_main/errors/session-expired")({
  component: RouteComponent,
  validateSearch: appErrorSearchSchema,
});

function RouteComponent() {
  const { from } = Route.useSearch();

  return <RoutedAppErrorPage type="session-expired" from={from} />;
}
